<h2 mat-dialog-title>Privacy Notice – Asterisk Supply Chain Solutions </h2>
<mat-dialog-content style="height: 500px; border: 1px solid black;" class="mx-1 mb-2">
  <ol start="1">
    <li><strong>Introduction</strong></li>
    <p>This Privacy Notice is intended to describe the practices EY follows in relation to the Asterisk Supply Chain
      Solutions&nbsp; (the &ldquo;<strong>Tool</strong>&rdquo;) with respect to the privacy of all individuals whose
      personal data is processed and stored in the Tool. This Privacy Notice should be read together with the <a
        href="https://www.ey.com/en_gl/privacy-statement">ey.com Privacy Statement</a>, and in case of any conflict with
      the <a href="https://www.ey.com/en_gl/privacy-statement">ey.com Privacy Statement</a>, the terms of this Privacy
      Notice will prevail.&nbsp; Please read this Privacy Notice carefully.&nbsp;</p>


    <li><strong>Who manages the Tool?</strong></li>
    <p>&ldquo;EY&rdquo; refers to one or more of the member firms of Ernst &amp; Young Global Limited
      (&ldquo;EYG&rdquo;),
      each of which is a separate legal entity and (so far as the provision of services to clients using the Tool is
      concerned) can (i) determine the purposes and means for data processing in its own right (i.e. act as a data
      controller or in a similar capacity) or (ii) process data solely on behalf of another entity (i.e. act as a data
      processor or in a similar capacity). The entity that is acting as data controller (or similar capacity) by
      providing
      this Tool on which your personal data will be processed and stored is EYGM Limited, an EY global entity. To the
      extent that EY acts as a data processor for its clients, the relevant client remains the ultimate data controller
      and will provide comprehensive information relating to the intended data processing.</p>
    <p>The personal data in the Tool is shared by EYGM Limited with one or more member firms of EYG (see &ldquo;Who can
      access your personal data&rdquo; section 6 below).</p>
    <p>The Tool is hosted externally in an EY Managed MS Azure Data Centre in the US, although the data centre in the
      Netherlands may be used upon request).</p>

    <li><strong>Why do we need your personal data? </strong></li>
    <p>The Tool has been developed for EY clients to assist them analyse their supply chains and make future decisions.
      The client uploads data directly into the Tool, which will then be analysed by using calculated metrics and data
      tables and product a summary/report, which is presented in a dashboard format, but can also be downloaded by the
      client in an excel format</p>
    Your personal data processed in the Tool is used as follows:
    <ul>
      <li>to grant you access to the Tool; and</li>
      <li>to analyse the data that is uploaded into the Tool to provide you with a summary of the analysis in a
        dashboard format or a downloadable copy.</li>
    </ul>

    <p>EY relies on the following basis to legitimize the processing of your personal data in the Tool: Processing of
      your personal data is necessary for the purposes of the legitimate interests pursued by the data controller or by
      a third party, except where such interests are overridden by the interests or fundamental rights and freedoms of the
      data subject which require protection of personal data. The specific legitimate interest(s) is for quality and risk
      management.</p>
    <p>You have the right to object at any time, on grounds relating to your particular situation, to the processing of
      personal data concerning you based on the above legitimate interest(s).</p>

    <li><strong>What type of personal data is processed in the Tool? </strong></li>
    The Tool processes these personal data categories:
    <ul>
      <li>First name;</li>
      <li>last name;</li>
      <li>email address;</li>
      <li>users role;</li>
      <li>information regarding the client relating to procurement, production, demand or supply;</li>
      <li>client supplier, manufacturer, vendor and client details, such as first and last name, business name, business
        address, email address and phone number;</li>
      <li>log data, such as who logged into the tool, for how long and what analysis they conducted or edits made to a
        previous analysis (such as which parameters were changed); and</li>
      <li>audit log data, such as masked user ID, masked IP address, region, browser type and operation system.</li>
    </ul>
    This data is sourced:
    <ul>
      <li>from a feed from other EY systems such as GHRD and GHRS; and</li>
      <li>directly from the client.</li>
    </ul>

    <li><strong>Sensitive personal data</strong></li>

    <p>Sensitive personal data reveals your racial or ethnic origin, political opinions, religious or philosophical
      beliefs, trade union membership, genetic data, biometric data, data concerning health or data concerning sex life
      or sexual orientation.</p>
    <p>EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool&rsquo;s intention
      is not to process such information.</p>

    <li><strong>Who can access your personal data?</strong></li>

    <p>Your personal data is accessed in the Tool by the following persons/teams:</p>
    <table  class="table table-bordered">
      <tbody>
        <tr class="bg-warning">
          <td width="113">
            <p><strong>USER GROUP</strong></p>
          </td>
          <td width="113">
            <p><strong>LOCATION</strong></p>
          </td>
          <td width="123">
            <p><strong>PURPOSE</strong></p>
          </td>
          <td width="91">
            <p><strong>ACCESS</strong></p>
          </td>
          <td width="75">
            <p><strong>AMOUNT</strong></p>
          </td>
        </tr>
        <tr>
          <td width="113">
            <p>EY Project Users and administrators</p>
          </td>
          <td width="113">
            <p>Global</p>
          </td>
          <td width="123">
            <p>To review the reports and assist the client with its supply chain planning.</p>
          </td>
          <td width="91">
            <p>All</p>
          </td>
          <td width="75">
            <p>10</p>
          </td>
        </tr>
        <tr>
          <td width="113">
            <p>EY Technical Support</p>
          </td>
          <td width="113">
            <p>US, Poland, Argentina and India.</p>
          </td>
          <td width="123">
            <p>To provide assistance when there is a technical issue within the Tool</p>
          </td>
          <td width="91">
            <p>All</p>
          </td>
          <td width="75">
            <p>10</p>
          </td>
        </tr>
        <tr>
          <td width="113">
            <p>Client and Client Personnel</p>
          </td>
          <td width="113">
            <p>Global</p>
          </td>
          <td width="123">
            <p>To analyse its procurement, demand and supply chains.</p>
          </td>
          <td width="91">
            <p>All</p>
          </td>
          <td width="75">
            <p>50</p>
          </td>
        </tr>
        <tr>
          <td width="113">
            <p>Developers and Testers</p>
          </td>
          <td width="113">
            <p>US, Poland, Argentina and India</p>
          </td>
          <td width="123">
            <p>Develop and test product functionalities</p>
          </td>
          <td width="91">
            <p>All</p>
          </td>
          <td width="75">
            <p>10</p>
          </td>
        </tr>
        <tr>
          <td width="113">
            <p>MS Azure</p>
          </td>
          <td width="113">
            <p>US and Netherlands</p>
          </td>
          <td width="123">
            <p>Hosting</p>
          </td>
          <td width="91">
            <p>No access to the data. Only provides hosting services.</p>
          </td>
          <td width="75">
            <p>&lt;50</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p>The access rights detailed above involves transferring personal data in various jurisdictions (including
      jurisdictions outside the European Union) in which EY operates (EY office locations are listed at <a
        href="http://www.ey.com/ourlocations">www.ey.com/ourlocations</a>). An overview of EY network entities providing
      services to external clients is accessible <a href="https://www.ey.com/en_uk/legal-statement">here</a> (See
      Section
      1 (About EY) - &ldquo;View a list of EY member firms and affiliates&rdquo;). EY will process your personal data in
      the Tool in accordance with applicable law and professional regulations in your jurisdiction. Transfers of
      personal
      data within the EY network are governed by EY&rsquo;s <a
        href="https://www.ey.com/en_gl/data-protection-binding-corporate-rules-program">Binding Corporate Rules</a>.</p>
    <p>We transfer or disclose the personal data we collect to third-party service providers (and their subsidiaries and
      affiliates) who are engaged by us to support our internal ancillary processes. For example, we engage service
      providers to provide, run and support our IT infrastructure (such as identity management, hosting, data analysis,
      back-up, security and cloud storage services) and for the storage and secure disposal of our hard copy files. It
      is
      our policy to only use third-party service providers that are bound to maintain appropriate levels of data
      protection, security and confidentiality, and that comply with any applicable legal requirements for transferring
      personal data outside the jurisdiction in which it was originally collected.</p>

    <p>To the extent that personal data has been rendered anonymous in such a way that you or your device are no longer
      reasonably identifiable, such information will be treated as non-personal data and the terms of this Privacy
      Notice
      will not apply.</p>

    <p>For data collected in the European Economic Area (EEA) or which relates to individuals in the EEA, EY requires an
      appropriate transfer mechanism as necessary to comply with applicable law. The transfer of personal data from the
      Tool to MS Azure is governed by an agreement between EY and the service provider that includes standard data
      protection clauses adopted by the European Commission.</p>

    <li><strong>Data retention</strong></li>
    <p>Our policy is to retain personal data only for as long as it is needed for the purposes described in the section
      &ldquo;Why do we need your personal data&rdquo;. Retention periods vary in different jurisdictions and are set in
      accordance with local regulatory and professional retention requirements.</p>
    <p>In order to meet our professional and legal requirements, to establish, exercise or defend our legal rights and
      for
      archiving and historical purposes, we need to retain information for significant periods of time.</p>
    The policies and/or procedures for the retention of personal data in the Tool are:
    <ul>
      <li>For personal data: then data retention is in accordance with EY Records Retention Global Policy and the
        applicable Global, Area, Region or Country Retention Schedule. Retention periods vary per country depending on
        local policies and regulations. The standard retention period for many countries is 7 years unless you request
        for
        a retention period that is less than seven years; and</li>
      <li>For log data: this will be retained in accordance with the <a
          href="https://sites.ey.com/sites/informationsecurity/Policy%20Library/Logging_Policy.pdf">EY IT Logging
          Policy</a>.</li>
    </ul>
    <p>After the end of the data retention period, your personal data will be deleted.</p>

    <li><strong>Security</strong></li>

    <p>EY protects the confidentiality and security of information it obtains in the course of its business. Access to
      such information is limited, and policies and procedures are in place that are designed to safeguard the
      information
      from loss, misuse and improper disclosure. Additional information regarding our approach to data protection and
      information security is available in our <a
        href="https://www.ey.com/publication/vwLUAssets/ey-protecting-your-data/$FILE/ey-protecting-your-data.pdf">Protecting
        your data</a> brochure.</p>


    <li><strong>Controlling your personal data</strong></li>

    <p><a name="_edn1"></a>EY will not transfer your personal data to third parties (other than any external parties
      referred to in section 6 above) unless we have your permission or are required by law to do so. &nbsp;</p>
    <p>You are legally entitled to request details of EY&rsquo;s personal data about you.</p>
    <p>To confirm whether your personal data is processed in the Tool or to access your personal data in the Tool or
      (where applicable) to withdraw your consent, contact your usual EY representative or email your request to <a
        href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a>.</p>

    <li><strong>Object, rectification, erasure, restriction of processing or data portability</strong></li>


    <p>You can confirm your personal data is accurate and current. You can object to the processing of your personal
      data
      or request rectification, erasure, restriction of processing or a readily portable copy of your personal data by
      contacting your usual EY representative or by sending an e-mail to <a
        href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a>.</p>

    <li><strong>Complaints </strong></li>

    <p>If you are concerned about an alleged breach of privacy law or any other regulation, contact EY&rsquo;s Global
      Privacy Leader, Office of the General Counsel, 6 More London Place, London, SE1 2DA, United Kingdom or via email
      at
      <a href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a> or via your usual EY
      representative. An EY Privacy Leader will investigate your complaint and provide information about how it will be
      handled and resolved.</p>
    <p>If you are not satisfied with how EY resolved your complaint, you have the right to complain to your
      country&rsquo;s data protection authority. You can also refer the matter to a court of competent jurisdiction.
      &nbsp;</p>
    <p>Certain EY member firms in countries outside the European Union (EU) have appointed a representative in the EU to
      act on their behalf if, and when, they undertake data processing activities to which the EU General Data
      Protection
      Regulation (GDPR) applies. Further information and the contact details of these representatives are available <a
        href="https://www.ey.com/en_gl/data-protection-representative">here</a>.</p>

    <li><strong>Contact us</strong></li>

    <p>If you have additional questions or concerns, contact your usual EY representative or email <a
        href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a>.</p>
  </ol>
</mat-dialog-content>
<mat-dialog-actions class="mb-1 d-flex">
  <div class="flex-fill"></div>
  <button class="btn btn-outline-dark mr-2" (click)="logout()">Decline</button>
  <button class="btn btn-outline-dark" (click)="closeDialog()">Accept</button>
</mat-dialog-actions>